module.exports = __webpack_public_path__ + "media/images/game_icon/en/AB1042-784b1f72b59eff8edac437154c3cdf7f.png";